import { render, staticRenderFns } from "./LayoutHorizontalSidenav.vue?vue&type=template&id=2529c00e"
import script from "./LayoutHorizontalSidenav.vue?vue&type=script&lang=js"
export * from "./LayoutHorizontalSidenav.vue?vue&type=script&lang=js"
import style0 from "./LayoutHorizontalSidenav.vue?vue&type=style&index=0&id=2529c00e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports